import { get } from 'lodash'
import { required } from 'utils/validation'

const validate = values => {
  let errors = {
    password: required(get(values, 'password')),
    passwordVerify: required(get(values, 'passwordVerify'))
  }

  if (
    get(values, 'password') &&
    get(values, 'passwordVerify') &&
    get(values, 'password') !== get(values, 'passwordVerify')
  ) {
    errors = {
      ...errors,
      passwordVerify: {
        text: "Passwords don't match",
        intlKey: 'errors.passwords_dont_match',
        values: {}
      }
    }
  }

  return errors
}

export default validate
